module.exports = __webpack_public_path__ + "img/SKMJ_limit14.b505d88a.png";